import { Box, Typography } from '@mui/material';
import {
	getDiagramTourSteps,
	getIntegrationTemplateHeaderTourSteps,
	getTaskConfigurationTourSteps,
	getTaskDestinationTourSteps,
	getTaskGeneralTourSteps,
	getTaskNodeTourSteps,
} from '../component-tours';
import { AdvancedTourDefinition } from '../shared-types';
import { getSetVariableTourSteps } from '../task-tours/set-variable-tour-steps';
import { RouteTourProps } from './route-tour-props';
import ButtonWrapper from '../../../components/custom-controls/button-wrapper/button-wrapper';

type EditIntegrationSteps =
	'editFlow' | 'editFlowHeader' | 'taskWizard' | 'editTaskDrawer' | 'editTask';

export function getEditIntegrationTemplateTourSteps({
	defaultStyles,
}: RouteTourProps): Record<EditIntegrationSteps, AdvancedTourDefinition> {
	return {
		editFlow: {
			start: 'task-diagram',
			steps: [...getDiagramTourSteps({ defaultStyles, isEdit: true })],
			autoStartNext: false,
			nextTour: 'taskWizard',
		},
		taskWizard: {
			start: 'task-type',
			steps: [
				...getTaskGeneralTourSteps({ defaultStyles }),
				{
					id: 'task-cancel',
					selector: '[data-tour="task-cancel"]',
					content:
						'Clicking cancel will close the wizard and discard any changes, if the task was dragged to the diagram it will not be added to the flow.',
					styles: defaultStyles,
				},
				{
					id: 'task-finish',
					selector: '[data-tour="task-finish"]',
					content:
						'Once the basic task information has been completed, clicking on "Finish" will close the wizard and add the task to the diagram for the flow.',
					styles: defaultStyles,
				},
			],
			nextTour: 'editTask',
			autoStartNext: false,
		},
		editTask: {
			start: 'task-node',
			steps: [
				{
					id: 'task-node',
					selector: '[data-tour="task-node-0"]',
					content:
						'This is your newly created "Task Node" as you progress in creating a flow, you will see multiple nodes.',
					styles: defaultStyles,
				},
				...getTaskNodeTourSteps({ defaultStyles }),
				{
					id: 'task-node-open-drawer',
					selector: '[data-tour="task-node-0"]',
					content:
						'To continue with our tutorial, click on the newly added node, this will open up the configuration drawer, double clicking on the node will open the drawer in full width, give it a try.',
					styles: defaultStyles,
				},
			],
			nextTour: 'editTaskDrawer',
			autoStartNext: false,
		},
		editTaskDrawer: {
			start: 'task-drawer',
			steps: [
				...getTaskConfigurationTourSteps({ defaultStyles }),
				...getTaskDestinationTourSteps({ defaultStyles }),
				...getSetVariableTourSteps({ defaultStyles }),
				{
					id: 'success-task-setup',
					selector: '[data-tour="task-drawer"]',
					disableActions: true,
					content: ({ setIsOpen }) => (
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
							<Typography>
								Once completed with setting the default configuration for your task, click on on the
								button below to continue with the tour.
							</Typography>
							<ButtonWrapper
								label="Continue Tour"
								variant="light"
								id="continue-tour"
								onClick={() => setIsOpen(false)}
							/>
						</Box>
					),
					styles: defaultStyles,
				},
			],
			autoStartNext: false,
			nextTour: 'editFlowHeader',
		},
		editFlowHeader: {
			start: 'paste-task',
			steps: [...getIntegrationTemplateHeaderTourSteps({ defaultStyles, isEdit: true })],
			autoStartNext: false,
		},
	};
}
